<template>
  <div class="ts-space-y-3">
    <div class="row">
      <div class="col-md-12">
        <label class="required">{{ $t('stockCount.approveBy') }}</label>
        <a-select
          class="ts-w-full"
          v-model="model.approved_by"
          :options="userList"
          showSearch
          :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
        ></a-select>
				<div class="validate" v-if="errors.has('approved_by')">
					{{ errors.first('approved_by') }}
				</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required">{{ $t('stockCount.acknowledgeBy') }}</label>
        <a-select
          v-model="model.acknowledge_by"
          :options="userList"
          showSearch
          :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
          class="ts-w-full"
        ></a-select>
				<div class="validate" v-if="errors.has('acknowledge_by')">
					{{ errors.first('acknowledge_by') }}
				</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label>{{ $t('stockCount.remark') }}</label>
        <textarea
          v-model="model.remarks"
          rows="3"
          class="form-control"
        ></textarea>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-flex ts-justify-end ts-space-x-3">
        <ts-button @click="$emit('cancel')">{{ $t('cancel') }}</ts-button>
        <ts-button
					:waiting="waiting"
					@click.prevent="onGenerate" 
					color="primary">{{ $t('save') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  props: ['stockCountId', 'validate'],
  data() {
    return {
      loading: false,
			waiting: false,
			errors: new Errors(),
      users: [],
      model: {
        stock_count_id: null,
        acknowledge_by: null,
        approved_by: null,
        remarks: null,
      },
    }
  },
  created() {
    this.fetchUser()
		this.model.stock_count_id = this.stockCountId
  },
  computed: {
    userList() {
      return this.users.map((el) => ({
        value: el.user_id,
        label: el.employee.employee_name_en,
      }))
    },
  },
  methods: {
    fetchUser() {
      this.loading = true
      this.$store
        .dispatch('stock/stockCount/getUser')
        .then((response) => {
          this.users = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    onGenerate() {
      this.waiting = true
      this.$store
        .dispatch('stock/stockCount/generate', this.model)
        .then(response => {
          this.$toasted.success(response.message)
					this.clearInput()
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
		clearInput(){
			this.model.stock_count_id = null
    	this.model.acknowledge_by = null
    	this.model.approved_by = null
    	this.model.remarks = null
		}
  },
  watch: {
    stockCountId: function () {
      this.model.stock_count_id = this.stockCountId
    },
  },
}
</script>